"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addMonths = function addMonths(date, months) {
  return (0, _dayjs["default"])(date).add(months, 'month').toISOString();
};

var _default = addMonths;
exports["default"] = _default;